import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";

import { IStoreState } from "../../../../../../reducers/types";
import {
  fetchFlights,
  setSelectedFlight,
  setOpenModal,
} from "../../../../../TripsList/actions/actions";
import {
  getAirlinesMap,
  getAirportMap,
  getSelectedFlight,
  getTripsFilter,
} from "../../../../../TripsList/reducer";
import { MobileFlightItineraryDetails } from "./component";

const mapStateToProps = (state: IStoreState) => ({
  flight: getSelectedFlight(state),
  airportMap: getAirportMap(state),
  airlineMap: getAirlinesMap(state),
  tripsFilter: getTripsFilter(state),
});

const mapDispatchToProps = {
  setSelectedFlight,
  setOpenModal,
  fetchFlights,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileFlightItineraryDetailsConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobileFlightItineraryDetails = connector(
  withRouter(MobileFlightItineraryDetails)
);
